// extracted by mini-css-extract-plugin
export default {"cls1":"Xm1Pk1mGVki0oZOSnIgO","cls2":"CLniGItgVvAyNB9K9Lly Xm1Pk1mGVki0oZOSnIgO"};